var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisionimage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 636.016,
    height: 575.988,
    viewBox: "0 10 636.016 575.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(-306.992 -1826.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M272,0C422.221,0,544,113.048,544,252.5S301.923,191.3,97.989,461.118C15.367,461.118-37.059,331.47-87.12,277.3c-40.639-43.974,185.109,25.1,185.109-37.649C97.989,100.2,121.779,0,272,0Z",
    transform: "translate(399.008 1941.071)",
    fill: "#e2f7fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    transform: "translate(333 1867.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M127.742,191.888c-30.368-7.871-54.107-36.511-60.409-43.414a13.021,13.021,0,0,1-1.816-2.98l0,0C59.489,133,49.76,91.934,47.593,82.626c-.147-.633-.257-1.117-.329-1.438-.072-.295-.107-.449-.107-.449l17.275-7.549s1.407,16.562,9.729,29.926,15.991,34.545,15.991,34.545c16.265,8,33.664,22.876,33.664,22.876C132.894,179.565,127.742,191.888,127.742,191.888Z",
    transform: "translate(-39.394 -51.372)",
    fill: "#f9b587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M121.6,167.692c-30.368-7.871-54.107-36.511-60.409-43.414a13.021,13.021,0,0,1-1.816-2.98c.352.3,22.812,19.565,31.255,24.445,8.51,4.918,18.143,9.287,22.876,5.968s6.058-9.644,4.168-15.371C126.75,155.37,121.6,167.692,121.6,167.692Z",
    transform: "translate(-33.25 -27.176)",
    fill: "#f39568"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M50.817,88.911c3.329-.11,14.947-3.1,16.39-3.76.5-.231.714-.956.771-1.8.452-.487,3.392-3.715,4.1-6.246.388-1.393-1.051-2.575-2.78-3.58,1.447-2.914,1.709-10.738-1.867-13.624-3.894-3.146-7.633.735-7.633.735-4.462-3.622-7.267,1.163-7.267,1.163-2.1-1.395-5.866,1.371-5.866,1.371-1.931-1.016-4.123,1.019-4.614,2.9s2.079,17.714,3.485,19.5S50.817,88.911,50.817,88.911Z",
    transform: "translate(-41.992 -58.673)",
    fill: "#f9b587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M57.888,76.468c1.713,2.429,3.551.815,3.551.815-.6.135-1.518-.682-2.239-1.467a6.469,6.469,0,0,1-1.027-1.234l0-.008a4.017,4.017,0,0,1-.634-3.266c.652-2.283,1.79-2.612,1.79-2.612L57.62,61.643a32.258,32.258,0,0,0,.144,6.9,5.579,5.579,0,0,0-.473,7.118,1.958,1.958,0,0,1-2.31.528,5.431,5.431,0,0,1-2.636-3.239L50.1,63.256s.582,11.134,2.735,13.182C55.692,79.155,57.888,76.468,57.888,76.468Z",
    transform: "translate(-37.915 -57.179)",
    fill: "#f39568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M46.266,64.694s1.45,8.18,2.331,9.84a3.136,3.136,0,0,0,4.368,1.284,2.4,2.4,0,0,0,1.144-1.891l1.535,1.294s-2.826,4.667-6.711,1.338C46.989,74.893,46.266,64.694,46.266,64.694Z",
    transform: "translate(-39.842 -55.644)",
    fill: "#f39568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M49,71.909A3.13,3.13,0,0,1,47.71,74.59c-1.4.879-2.429.443-2.937-.466a1.869,1.869,0,0,0,1.686,1.6c2.058.334,3.514-1.9,3.884-2.683Z",
    transform: "translate(-40.593 -52.015)",
    fill: "#f39568"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M51.283,78.935a5.589,5.589,0,0,1-3.726,1.014c-.147-.633-.257-1.117-.329-1.438A13.13,13.13,0,0,0,51.283,78.935Z",
    transform: "translate(-39.358 -48.695)",
    fill: "#f39568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M60.185,76.038a10.745,10.745,0,0,1-3.419,2.206,6.4,6.4,0,0,0,3.649-.908Z",
    transform: "translate(-34.561 -49.939)",
    fill: "#f39568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M78.8,116.086s-5.8,4.856-9.078,5.361a12.12,12.12,0,0,0,12.2-3.75Z",
    transform: "translate(-28.044 -29.797)",
    fill: "#f39568"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M88.711,242.077a5.293,5.293,0,0,0,3.245,1.855c1,15.964,3.125,29.5,6.293,35.324,9.762,17.932,73.367,19.125,86.611,3.488s9.763-107.168-12.3-118.842c-16.472-8.716-48.378-6.374-63.492-4.626a15.454,15.454,0,0,0-13.2,11.4c-2.581,9.865-4.05,25.168-4.465,41.317a9.07,9.07,0,0,0-2.716.852C85.705,214.367,86.87,239.386,88.711,242.077Z",
    transform: "translate(-19.424 -8.91)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M281.755,155.481s-4.858,18.013-12.547,38c-1.162,3.018-2.387,6.085-3.673,9.141-5.23,12.449-11.422,24.726-18.1,33.086-3.563,4.456-7.259,7.8-11.023,9.456,0,0-10.781,1.512-18.345-3.027S181,222.972,177.409,216.667c0,0,11.347-16.087,22.126-17.532,0,0,4.005,2.068,9.68,5.367a219.788,219.788,0,0,1,21.218,13.836q1.021.766,2.009,1.543S233,218.8,234,216.917c2.553-4.79,8.008-14.76,14.616-25.294,1.411-2.254,2.878-4.539,4.38-6.8.334-.5.67-1.005,1.007-1.5,11.724-17.4,13.238-30.116,13.238-30.116S278.54,152.256,281.755,155.481Z",
    transform: "translate(26.115 -11.195)",
    fill: "#f9b587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M245.38,182.852c-1.162,3.018-2.387,6.085-3.673,9.141l-16.919-11c1.411-2.254,2.878-4.539,4.38-6.8Z",
    transform: "translate(49.943 -0.571)",
    fill: "#f39568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M247.437,220.289c-3.563,4.456-7.259,7.8-11.023,9.456,0,0-10.781,1.512-18.345-3.027S181,207.558,177.409,201.253c0,0,11.347-16.087,22.126-17.532,0,0,4.005,2.068,9.68,5.367-.658,2.262-3.272,10.39-7.967,14.325-5.484,4.591,7.187,15.183,18.157,19.909S238.018,227.846,247.437,220.289Z",
    transform: "translate(26.115 4.219)",
    fill: "#f39568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M214.268,210.753c1.262-5.17-1.578-13.779-1.578-13.779q1.021.767,2.009,1.543s.556-1.082,1.557-2.965C217.366,206.573,214.268,210.753,214.268,210.753Z",
    transform: "translate(43.859 10.169)",
    fill: "#f39568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M190.222,402.132c-10.088-5.8-13.617-11.6-19.669-21.686-3.592-5.991-6.921-11-9.031-14.086a7.006,7.006,0,0,1-.439-7.19c.09-.177.185-.356.283-.541,2.372-4.486,6.309-10.8,9.706-10.965l3.843,2.092L188.206,357s5.8,13.325,5.544,19.143c-.215,5.08,9.593,16.846,12.562,23.465a13.017,13.017,0,0,1,.594,1.563,6.084,6.084,0,0,1,.212.965C207.829,407.721,200.31,407.933,190.222,402.132Z",
    transform: "translate(17.507 86.672)",
    fill: "#b0b1ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M190.222,398.463c-10.088-5.8-13.617-11.6-19.669-21.686-3.592-5.991-6.921-11-9.031-14.086a7.006,7.006,0,0,1-.439-7.19c.09-.177.185-.356.283-.541a29.547,29.547,0,0,0,5.6,11.6c4.539,5.3,11.2,17.21,12.789,19.48s12.844,12,19.929,13.427c5.746,1.162,6.793-.06,7.228-1.973a6.085,6.085,0,0,1,.212.965C207.829,404.052,200.31,404.264,190.222,398.463Z",
    transform: "translate(17.507 90.342)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M190.222,402.132c-10.088-5.8-13.617-11.6-19.669-21.686-3.592-5.991-6.921-11-9.031-14.086a7.006,7.006,0,0,1-.439-7.19c.09-.177.185-.356.283-.541,2.372-4.486,6.309-10.8,9.706-10.965l3.843,2.092s-7.512,6.736-5.117,14.173,10.424,18.662,14.6,23.58c4.055,4.766,13.03,13.083,21.911,12.1a13.017,13.017,0,0,1,.594,1.563,6.084,6.084,0,0,1,.212.965C207.829,407.721,200.31,407.933,190.222,402.132Z",
    transform: "translate(17.507 86.672)",
    fill: "#2c2a40",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M193.34,426.939c-.231,6.691-4.99,12.846-15.494,11.053-11.834-2.015-15.145-11.851-17.917-17.9s-9.332-26.979-12.1-35.3c-1.5-4.509-1.058-9.471-.337-13.068a33.65,33.65,0,0,1,1.416-5.11l4.265.646,24.158,3.661a68.842,68.842,0,0,1,5.549,20.426c.863,9.278,7.077,21.321,9.487,29.343v.008a24.509,24.509,0,0,1,.852,3.681A15.11,15.11,0,0,1,193.34,426.939Z",
    transform: "translate(10.732 96.201)",
    fill: "#b0b1ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M193.34,426.939c-.231,6.691-4.99,12.846-15.494,11.053-11.834-2.015-15.145-11.851-17.917-17.9s-9.332-26.979-12.1-35.3c-1.5-4.509-1.058-9.471-.337-13.068a33.65,33.65,0,0,1,1.416-5.11l4.265.646c-.4,4.192,1.407,16.071,4.742,22.448,4.157,7.943,7.261,25.406,14.5,33.159s20.225,9.2,19.951-2.169a24.509,24.509,0,0,1,.852,3.681A15.11,15.11,0,0,1,193.34,426.939Z",
    transform: "translate(10.732 96.201)",
    fill: "#2c2a40",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M193.34,425.229c-.231,6.691-4.99,12.846-15.494,11.053-11.834-2.015-15.145-11.851-17.917-17.9s-9.332-26.979-12.1-35.3c-1.5-4.509-1.058-9.471-.337-13.068a167.616,167.616,0,0,0,7.5,25.155c6.049,15.444,10.878,29.013,15.092,33.553S190.922,436.275,193.34,425.229Z",
    transform: "translate(10.732 97.911)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M95.484,150.441l9.475,2.985s-1.6,6.7-4.342,6.691S94.664,158.653,95.484,150.441Z",
    transform: "translate(-15.154 -12.519)",
    fill: "#00497b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399",
    transform: "translate(100.921 283.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M186.789,318.784c1.835,4.587.123,9.384-1.909,17.045,8.078-11.76,21.578-30.409,21.578-30.409L167.12,293.282S184.772,313.742,186.789,318.784Z",
    transform: "translate(-79.981 -224.207)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M283.769,312.76a12.29,12.29,0,0,0-2.638-4.883c-4.07-4.689-16.1-17.108-40.219-31.541-30.762-18.406-36.563-16.893-51.943-28.24,0,0-52.6-5.916-74.2,14.963-.224.215-.443.436-.658.654a29.354,29.354,0,0,0-4.97,6.748s0,27.287,10.779,37.243,44.588,45.184,47.867,44.86c0,0,.249,5.472,4.286,5.726,0,0-5.549,22.44-3.279,32.026,0,0-3.529,8.068-1.763,13.866s-.506,11.6-.506,15.13,3.025,19.165,12.859,22.445,20.679-.254,21.435-8.828-1.259-14.12-.5-18.913c.2-1.3,1.1-5.11,2.334-10.148,3.631,2.269,9.353,3.98,11.283,3.594,2.519-.5,7.814-15.383,11.093-16.39s14.876-15.383,23.2-23.452C256.2,359.886,289.654,335.032,283.769,312.76ZM196.28,316.4l39.338,12.135s-13.5,18.651-21.579,30.41c2.035-7.659,3.745-12.459,1.91-17.043C213.933,336.855,196.28,316.4,196.28,316.4Z",
    transform: "translate(-109.141 -247.322)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    transform: "translate(4.97 15.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M114.249,260.13l-1.491.249c-.14-.831-.245-1.479-.31-1.9.215-.218.434-.439.658-.654l.748-.113S113.995,258.614,114.249,260.13Z",
    transform: "translate(-112.448 -257.718)",
    fill: "#5b5b6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    transform: "translate(0.903 5.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M114.535,261.556l-1.486.272c.3,1.637.609,3.275.93,4.868l1.483-.3C115.146,264.816,114.834,263.185,114.535,261.556Zm1.623,8.185-1.479.317c.364,1.68.733,3.309,1.1,4.838l1.471-.356C116.884,273.023,116.518,271.409,116.159,269.741Zm1.925,8.1-1.464.391c.454,1.713.915,3.325,1.369,4.781l1.444-.451C118.984,281.126,118.53,279.54,118.084,277.842Zm2.429,7.932-1.423.518a37.383,37.383,0,0,0,1.994,4.634l1.335-.708A36.684,36.684,0,0,1,120.513,285.774Zm3.711,7.088-1.094,1.045c.738.776,1.918,1.966,3.506,3.539l1.063-1.073C126.122,294.81,124.952,293.63,124.223,292.862Zm5.923,5.908-1.06,1.082c1.093,1.067,2.284,2.224,3.551,3.454l1.055-1.09C132.423,300.992,131.236,299.837,130.146,298.77Zm6.013,5.825-1.051,1.09c1.153,1.108,2.349,2.254,3.577,3.427l1.045-1.093C138.506,306.846,137.309,305.7,136.16,304.6Zm6.052,5.783-1.045,1.1q1.777,1.684,3.6,3.407l1.036-1.1C144.6,312.641,143.392,311.5,142.212,310.379Zm6.082,5.749-1.037,1.1q1.817,1.7,3.616,3.386l1.033-1.109C150.711,318.394,149.5,317.262,148.294,316.128Zm6.12,5.716-1.03,1.108c1.237,1.151,2.459,2.274,3.643,3.359l1.02-1.115C156.866,324.113,155.651,322.99,154.414,321.843Zm6.165,5.663-1.018,1.12c1.29,1.172,2.523,2.284,3.684,3.317l1.007-1.132C163.1,329.783,161.866,328.674,160.579,327.506Zm6.237,5.567-.99,1.142c1.512,1.317,2.8,2.4,3.808,3.215l.95-1.18C169.585,335.449,168.318,334.378,166.817,333.073Zm6.419,5.008-.613,1.384c1.1.488,1.751,1.509,2.16,3.424l1.483-.314C175.917,340.949,175.256,338.974,173.236,338.081Zm3.533,7.948-1.5.174a30.012,30.012,0,0,0,.885,4.985l1.449-.428A29.063,29.063,0,0,1,176.769,346.029Zm-.443,8.283c-.095,1.249-.314,2.826-.673,4.815l1.491.269c.367-2.043.594-3.669.691-4.97Zm-1.32,8.159c-.254,1.247-.526,2.534-.8,3.839L174,367.3l1.479.311.212-.992c.275-1.308.549-2.6.8-3.851Zm-1.706,8.193c-.386,1.907-.678,3.457-.92,4.88l1.491.253c.237-1.407.529-2.943.911-4.833Zm.072,8.484-1.5-.185a36.146,36.146,0,0,0-.31,4.36c0,.234,0,.461.012.685l1.512-.053c-.008-.2-.011-.416-.011-.633A34.321,34.321,0,0,1,173.372,379.147Zm-.077,8.215-1.509.062c.03.836.05,1.706.05,2.591,0,.741-.012,1.494-.035,2.295l1.513.042c.023-.818.033-1.581.033-2.337C173.348,389.11,173.33,388.218,173.3,387.362Zm-1.641,8.344c-.05.89-.107,1.771-.159,2.641-.048.768-.1,1.532-.14,2.288l1.509.084c.042-.753.092-1.509.14-2.277.054-.875.11-1.76.159-2.651Zm1.1,12.5c-.041-.771-.06-1.569-.06-2.439,0-.549.008-1.1.023-1.653l-1.513-.038q-.023.852-.023,1.691c0,.9.02,1.721.062,2.523.015.237.018.487.023.744l1.512-.008Q172.773,408.6,172.755,408.2Zm-1.686,4.157c-.155,1.419-.4,3.045-.726,4.83l1.489.272c.334-1.823.583-3.484.738-4.94Zm-1.392,8.162c-.329,1.521-.7,3.132-1.117,4.788l1.468.367c.416-1.671.8-3.3,1.127-4.836Z",
    transform: "translate(-113.049 -261.556)",
    fill: "#5b5b6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(81.193 57.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M163.164,286.879s1.778.594,4.691,1.574l.484-1.434-4.694-1.577Z",
    transform: "translate(-163.164 -285.442)",
    fill: "#5b5b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M173.591,288.8c-1.671-.568-3.245-1.1-4.671-1.581l-.481,1.434c1.422.479,2.992,1.013,4.668,1.58Z",
    transform: "translate(-160.511 -284.55)",
    fill: "#5b5b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M178.176,329.749l1.237.874,2.837-4.028-1.237-.874Z",
    transform: "translate(-155.614 -265.184)",
    fill: "#5b5b6c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 4.925,
    height: 1.513,
    transform: "matrix(0.575, -0.818, 0.818, 0.575, 17.76, 71.382)",
    fill: "#5b5b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M173.238,335.715c.048.839.072,1.677.081,2.516l1.807-2.565-1.237-.875Z",
    transform: "translate(-158.097 -260.622)",
    fill: "#5b5b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M178.849,290.587c-1.6-.546-3.162-1.075-4.667-1.589l-.488,1.432c1.506.511,3.072,1.045,4.664,1.589Z",
    transform: "translate(-157.868 -283.654)",
    fill: "#5b5b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M194.574,296.1c-1.449-.521-3.007-1.082-4.644-1.661l-.5,1.426c1.634.579,3.188,1.135,4.634,1.656Z",
    transform: "translate(-149.956 -280.919)",
    fill: "#5b5b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M184.1,292.4c-1.554-.537-3.117-1.075-4.664-1.6l-.488,1.429c1.544.531,3.1,1.067,4.656,1.6Z",
    transform: "translate(-155.227 -282.751)",
    fill: "#5b5b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M191.618,311.926l1.12,1.017c1-1.1,2.17-2.387,3.3-3.669l-1.13-1C193.782,309.547,192.616,310.825,191.618,311.926Z",
    transform: "translate(-148.853 -273.958)",
    fill: "#5b5b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M195.277,307.847l1.162.975c1.232-1.471,2.239-2.75,3.075-3.918l-1.229-.882C197.471,305.157,196.488,306.409,195.277,307.847Z",
    transform: "translate(-147.013 -276.097)",
    fill: "#5b5b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M199.8,298.1c-1.1-.449-2.663-1.051-4.631-1.781l-.525,1.422c1.951.723,3.494,1.314,4.584,1.763Z",
    transform: "translate(-147.333 -279.971)",
    fill: "#5b5b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M200.9,299.137l-1.426.5a2.193,2.193,0,0,1,.11.711,7.557,7.557,0,0,1-1.12,3.34l1.329.723a8.812,8.812,0,0,0,1.3-4.062A3.611,3.611,0,0,0,200.9,299.137Z",
    transform: "translate(-145.408 -278.554)",
    fill: "#5b5b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M181.373,325.214l1.237.874,2.837-4.028-1.237-.874Z",
    transform: "translate(-154.006 -267.465)",
    fill: "#5b5b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M187.913,316.094l1.15.978c.852-1,1.855-2.137,3.246-3.676l-1.124-1.013C189.783,313.934,188.773,315.079,187.913,316.094Z",
    transform: "translate(-150.717 -271.892)",
    fill: "#5b5b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M186.978,317.263l-2.409,3.419,1.237.87,2.409-3.415c.135-.194.277-.391.427-.591l-1.214-.9C187.27,316.854,187.121,317.059,186.978,317.263Z",
    transform: "translate(-152.399 -269.749)",
    fill: "#5b5b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M184.189,294.031c1.581.549,3.14,1.09,4.652,1.622l.5-1.429c-1.512-.529-3.071-1.075-4.652-1.622Z",
    transform: "translate(-152.59 -281.841)",
    fill: "#5b5b6c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M247.954,213.831c-1.761,7.89-9.255,15.083-15.208,19.714h0a75.167,75.167,0,0,1-7.734,5.317l-3.533-3.045-10.965-9.437-5.269,10.871c-5.265,10.871-3.808,38.68-4.417,46.593-.534,6.906,10.115,23.084,12.255,28.61a2.919,2.919,0,0,1,.332,1.679c-.884,2.269-27.2,5.674-44.319,0s-51.773,15.055-52.908,14.676-2.127-50.987-7.422-73.489,3.529-81.515,3.529-81.515l-7.125-2.262-3.212-1.018c-9.332.507-6.362-10.462-6.362-10.462s.31,11.095,5.983,8.2c2.538-1.294,2.429-8.828,1.528-16.761-1.1-9.721-3.382-20.039-3.415-20.2.11.03,1.819.488,4.507,1.249,8.973,2.526,28.831,8.412,36.338,12.883,2.254,1.342,7.7,5.25,11.915,8.325,3.11,2.262,5.544,4.077,5.544,4.077,14.851,8.18,19.609,7.639,31.712,11.233.531.159,1.067.319,1.6.473,14.706,4.369,31.532,9.559,37.776,20.073,4.826,8.132,12.951,17.6,16.767,21.886C247.153,212.973,247.954,213.831,247.954,213.831Z",
    transform: "translate(-15.261 -22.141)",
    fill: "#00c3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M105.164,171.543l-3.212-1.018c-9.332.507-6.362-10.462-6.362-10.462s.31,11.095,5.983,8.2c2.538-1.294,2.429-8.828,1.528-16.761-1.1-9.721-3.382-20.039-3.415-20.2.11.03,1.819.488,4.507,1.249C106.439,141.616,110.463,161.667,105.164,171.543Z",
    transform: "translate(-15.261 -22.141)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M205.678,187.215c-1.761,7.89-9.255,15.083-15.208,19.714h0a75.168,75.168,0,0,1-7.734,5.317L179.2,209.2c12-8.117,20.493-18.325,23.792-24.971C204.291,185.694,205.678,187.215,205.678,187.215Z",
    transform: "translate(27.014 4.475)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M169.611,160.716c-2.369,6.306-5.965,11.995-24.465,7.521-20.832-5.038-9.441-20.967-9.441-20.967,3.108,2.262,3.449,2.547,3.449,2.547C154,158,154.4,156.243,166.5,159.837,167.034,159.994,169.075,160.561,169.611,160.716Z",
    transform: "translate(3.577 -14.114)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M198.449,205.92a75.168,75.168,0,0,1-7.734,5.317l-14.5-12.482-5.269,10.871c-5.265,10.871-3.808,38.68-4.417,46.593-10.39-24.711,7.8-69.984,7.8-69.984C179.575,196.435,198.135,205.694,198.449,205.92Z",
    transform: "translate(19.031 5.483)",
    fill: "#2c2a40",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M213.409,307.373c-.884,2.269-27.2,5.674-44.319,0s-51.773,15.055-52.908,14.676-2.127-50.987-7.422-73.489,3.529-81.515,3.529-81.515l-10.337-3.279c-9.332.507-6.362-10.462-6.362-10.462s.31,11.095,5.983,8.2c2.538-1.294,2.429-8.828,1.528-16.761,0,0,18.016,12.97,28.353,16,0,0-2.9,18.537-5.674,42.677s-1.005,40.74,4.539,57.633,17.936,33.08,35.128,34.846,33.932,13.791,47.628,9.793A2.919,2.919,0,0,1,213.409,307.373Z",
    transform: "translate(-15.261 -15.382)",
    fill: "#2c2a40",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    transform: "translate(137.585 57.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M198.842,129.317l0,0a8.7,8.7,0,0,1-.712.643L141.52,149.771s-8.459-3.894-7.963-18.68A19.461,19.461,0,0,1,144.6,113.642a14.76,14.76,0,0,1-1.232-1.416,1.023,1.023,0,0,1,.789-1.647,11.785,11.785,0,0,1,1.873.092,13.751,13.751,0,0,1-.308-2.044,1.026,1.026,0,0,1,1.562-.954,9.522,9.522,0,0,1,2.477,2.079l.074-.075a31.579,31.579,0,0,1,20.625-9.266c4.256-.243,9.443-.618,14.6-1.187,9.909-1.1,17.62.685,20.509-2.287C205.57,96.935,217.776,117.256,198.842,129.317Z",
    transform: "translate(-133.536 -96.935)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M177.588,116.086s5.789,13.552-3.8,21.626C173.787,137.712,172.37,121.485,177.588,116.086Z",
    transform: "translate(-113.381 -87.303)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M163.182,174.55c-.093.077-.192.158-.292.237a17.172,17.172,0,0,1-5.523,2.764c-4.913,1.559-15.767-3.24-20.487-5.523a2.711,2.711,0,0,1-1.359-3.4,62.036,62.036,0,0,0,3.888-21.962,61.813,61.813,0,0,1,4.625-22.021c-1.169,5.418.878,13.238,4.028,21.1C153.254,158.717,161.442,171.819,163.182,174.55Z",
    transform: "translate(-132.625 -82.997)",
    fill: "#f9b587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M187.148,146.325a20.44,20.44,0,0,1-3.687,11.846l-7.5,10.693A11.32,11.32,0,0,1,163.5,173.23c-5.34-1.574-12.249-4.588-17.47-10.3-9.855-10.778-5.438-28.831-5.438-28.831s5.5-18.062,22.41-21.234,30.353,8.77,30.353,8.77l-1.4,13.244a20.433,20.433,0,0,1-3.216,9.018Z",
    transform: "translate(-130.483 -89.192)",
    fill: "#f9b587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M169.994,126.021s-6.479-10.451-14.221-4.395l.589,2.185s7.223-3.7,12.491,4.461Z",
    transform: "translate(-122.352 -85.466)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M175.81,138.16a20.24,20.24,0,0,1-1.063,6.641c-1.509-1.752-4.928-3.75-12.6-4.579,0,0,4.782-2.248,8.773-1.336a1.634,1.634,0,0,0,1.994-1.712l-.537-7.345a4.763,4.763,0,0,1,2.95-1.25,29.973,29.973,0,0,1,4.934.328,20.363,20.363,0,0,1-2.862,6.826Z",
    transform: "translate(-119.145 -81.027)",
    fill: "#f39568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M176.385,127.48a22.152,22.152,0,0,0-5.447-.274l-.812,2.149a15.707,15.707,0,0,1,5.659.473,1.312,1.312,0,0,0,1.7-.912l0-.026A1.261,1.261,0,0,0,176.385,127.48Z",
    transform: "translate(-115.133 -81.74)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M173.867,143.758l-19.815-6.942s-.382,11.529,10.478,13.92C173.048,152.61,173.867,143.758,173.867,143.758Z",
    transform: "translate(-123.218 -76.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M160.864,160.4l-.909,7.781c-.135.126-.28.258-.439.394-.093.077-.192.158-.292.237-2.917-1.336-15.117-7.444-16.331-16.412a23.615,23.615,0,0,1,1.5-12.625,14.233,14.233,0,0,1,1.844-3.248C148.671,155.722,160.864,160.4,160.864,160.4Z",
    transform: "translate(-128.958 -77.022)",
    fill: "#f39568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M148.709,127.917s-2.018-8.235-8.407-6.338-7.394,19.3,1.471,18.183S148.709,127.917,148.709,127.917Z",
    transform: "translate(-132.641 -84.683)",
    fill: "#f9b587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M164.49,112.976s-3.735.386-4.186,5.111-1.256,12.764-7.337,12.595-6.673,7.217-6.673,7.217l-4.349-1.051s-.43-13.131,2.466-17.6S159.506,108.315,164.49,112.976Z",
    transform: "translate(-129.318 -89.68)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M156.476,126.836s2.083-2.66,6.251-1.44,3.938,5.665,3.938,5.665S164.33,125.237,156.476,126.836Z",
    transform: "translate(-121.999 -82.782)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M169.537,131.288a3.871,3.871,0,0,1,3.2-.242c1.719.667,1.093,2.911,1.093,2.911S173.436,131.068,169.537,131.288Z",
    transform: "translate(-115.43 -79.902)",
    fill: "#2c2a40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(238.456 103.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 82.205,
    height: 54.432,
    transform: "matrix(0.845, 0.534, -0.534, 0.845, 29.077, 2.848)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M299.222,160.16l-29.078,46.016-69.492-43.913,3.006-.212,94.326-6.66.834,3.212,0,0Z",
    transform: "translate(-200.651 -113.4)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M282.351,158.6l-27.807,44.135-2.106-1.332L233.4,157.419l48.12-2.027Z",
    transform: "translate(-184.183 -113.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 78.612,
    height: 54.432,
    transform: "translate(30.877 0) rotate(32.289)",
    fill: "#2c2a40"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M260.774,146.748l-.009-.012a5,5,0,0,0-3.084-2.376c-.009-1.037-1.014-2.011-2.262-2.551a3.489,3.489,0,0,0-2.3-.126c-.355-1.268-1.707-2.26-2.617-1.978,0,0-.216.042-.586.128a2.751,2.751,0,0,0-.646-1.483h0c-.592-1.359-2.859-2.486-3.881-2.17,0,0-8.652,1.553-10.7,7.545s-4.674,12.918-1.61,12.492a5.469,5.469,0,0,0,2.9-2.206c-1.081,3.63-1.479,6.427.5,6.152,1.1-.152,2.424-1.455,3.657-3.225-.833,3.1-.977,5.335.807,5.089,1.608-.222,3.687-2.9,5.269-5.9-1.023,3.5-1.357,6.167.58,5.9,2.372-.329,4.037-5.151,6.418-8.833,2.792-4.313,2.7-1.772,5.711-2.934l2.2,1.39A5.491,5.491,0,0,0,260.774,146.748Z",
    transform: "translate(-185.05 -123.089)",
    fill: "#f9b587"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M153.208,154.59s2.4-19.968-5.878-21.594c-16.075-3.156-33.926,20.647-43.6,45.4-14.562,37.256,2.26,65.229,2.26,65.229l.3-14.269s-1.323-31.024,13.052-55.555,24.4-31.15,26.477-29.449S148,150.8,148,150.8Z",
    transform: "translate(-13.926 -21.435)",
    fill: "#2c2a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M159.127,159.535s4.808-12.432,20.221-6.892c13.48,4.847,12.087,19.217,10.007,38.13s-20.4,65.686-20.4,65.686-.78-16.478,1.3-26.312c0,0,12.608-41.58,8.069-58.034S163.67,160.9,163.67,160.9Z",
    transform: "translate(16.92 -12.127)",
    fill: "#2c2a40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(-68.191 1541.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(741.128 304.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M854.025,1078.9s-5.031-10.41-10.99-11.31-11.316,11.7-15.645,20.188-12.343,15.811-13.808,21.482-1.911,7.939,4.626,7.708a17.592,17.592,0,0,0,10.832-4.459l14.253-23.751,9.689-3.616Z",
    transform: "translate(-771.611 -631.339)",
    fill: "#d24b39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M977.021,1035.953a309.192,309.192,0,0,1,3.494,37.162c.318,17.469,1.906,30.174-12.7,31.128s-54.632-13.658-73.69-18.74-28.268-7.623-33.35-3.812-17.787,15.564-17.787,15.564-3.176-4.447,2.859-13.658,6.034-11.117,11.752-13.023a16.128,16.128,0,0,0,8.258-6.035,3.39,3.39,0,0,0,3.177,2.541c2.541,0,40.021.318,53.043-1.27a225.79,225.79,0,0,1,27.634-1.271l-3.494-18.423Z",
    transform: "translate(-783.922 -618.144)",
    fill: "#a53d35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M824.72,1181.526s-9.211-6.988-14.928-5.082-4.765,15.563-4.765,25.093-3.811,19.693-2.541,25.41,1.906,7.941,7.623,4.764a17.59,17.59,0,0,0,7.623-8.893l1.906-27.634,6.988-7.623Z",
    transform: "translate(-767.248 -676.687)",
    fill: "#d24b39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M899.534,1065.484s7.623,12.388,13.658,20.963a136.493,136.493,0,0,0,10.482,13.341A398.1,398.1,0,0,0,882.7,1114.4c-23.822,9.847-36.528,22.234-48.6,17.469,0,0-.635,6.353-7.305,12.388,0,0-.953,7.306-1.589,14.611s-1.27,11.752,1.906,14.294c0,0,5.4-14.929,9.846-20.963s6.035-7.623,19.057-10.482,56.538-4.447,75.278-7.623,25.728-3.177,30.492-13.34-1.588-22.869-6.988-39.068-8.576-24.457-8.576-24.457Z",
    transform: "translate(-776.631 -627.029)",
    fill: "#b24639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M900.58,477.62s-7.306-1.906-16.2,6.034-9.212,23.5-7.941,32.08,3.494,14.929-1.271,21.281-10.482,17.469-8.893,29.856,2.541,13.023,0,22.869-.953,19.057,2.859,27.634,5.717,9.846,4.447,17.787-19.057,9.211-20.963,24.14,5.082,17.469,5.082,28.586,3.494,26.045,15.246,27,15.246-1.271,25.41,3.812,34.622,6.988,45.421-2.541,4.764-35.574,7.305-50.82,6.035-32.08,7.305-47.009,9.212-27.633,2.859-51.456-7.623-24.775-7.306-38.433-2.223-18.1-10.164-25.092-9.212-9.529-12.388-18.423S910.743,466.5,900.58,477.62Z",
    transform: "translate(-788.158 -382.837)",
    fill: "#1c2941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M921.09,829.629s-2.484.718-2.8,6.753-.317,6.67-.317,6.67a158.966,158.966,0,0,0-23.5,28.9c-10.8,17.151-7.94,35.892-2.859,50.5s22.551,51.773,22.551,51.773a368.662,368.662,0,0,0,38.115-3.812c20.645-3.176,45.1-18.74,45.1-18.74s-10.8-43.833-15.564-64.479-8.258-36.844-8.258-36.844,4.129-9.846-1.588-15.246S921.09,829.629,921.09,829.629Z",
    transform: "translate(-802.69 -531.966)",
    fill: "#5a98af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M1038.062,448.93s6.864-11.7,6.685-16.249-3.339-26.11-5.269-36.18-3.075-28.385-3.075-28.385a33.443,33.443,0,0,0-7.04-9.6c-4.868-4.647-5.578-4.642-8.171-9.024s-4.759-8.626-3.344-9.348,5.145,3.793,7.709,4.624-3.841-18.009-3.593-22.414,6.08-3.459,11.069-1.37,9,6.461,9.609,11.143.5,8.661,1.26,15.047,1.145,18.316,1.145,18.316,6.861,22.53,11.228,35.278,13.273,42.08,9.5,50.066a79.585,79.585,0,0,1-8.55,13.991Z",
    transform: "translate(-857.123 -318.779)",
    fill: "#b24639"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(167.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M1035.837,337.594a1,1,0,0,1-1-.936c-.312-4.64-4.476-16.749-4.518-16.871a1,1,0,1,1,1.895-.654c.175.508,4.294,12.487,4.622,17.391a1,1,0,0,1-.933,1.067Z",
    transform: "translate(-1030.265 -318.457)",
    fill: "#8e342c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(172.921 1.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M1043.795,338.635a1,1,0,0,1-1-.994c-.034-4.061-3.6-15.185-3.631-15.3a1,1,0,0,1,1.908-.614c.151.469,3.692,11.53,3.727,15.894a1,1,0,0,1-.994,1.01Z",
    transform: "translate(-1039.113 -321.035)",
    fill: "#8e342c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    transform: "translate(178.211 5.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M1051.718,342.661h-.023a1,1,0,0,1-.98-1.024c.1-4.465-2.443-12.208-2.468-12.286a1,1,0,0,1,1.9-.629c.109.331,2.675,8.152,2.569,12.958A1,1,0,0,1,1051.718,342.661Z",
    transform: "translate(-1048.196 -328.034)",
    fill: "#8e342c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M799.948,492.114s-11.435-7.306-13.34-11.435-8.894-24.775-11.752-34.621-10.164-26.681-10.164-26.681a33.44,33.44,0,0,1,1.906-11.752c2.223-6.352,2.859-6.67,3.176-11.752s.318-9.846-1.27-9.846-2.859,5.717-4.765,7.623-4.765-17.787-6.988-21.6-6.988-.318-10.482,3.811-5.082,9.846-3.494,14.294,3.494,7.94,5.717,13.976,7.305,16.834,7.305,16.834,4.129,23.187,6.035,36.527,7.305,43.515,14.294,48.914a79.538,79.538,0,0,0,13.975,8.576Z",
    transform: "translate(-742.158 -340.158)",
    fill: "#b24639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M884.1,581.3a155.856,155.856,0,0,1-21.6-8.576c-9.211-4.765-31.127-20.011-31.127-20.011s-3.177,6.67-6.988,13.658a121.321,121.321,0,0,0-6.988,16.517s16.2,7.623,28.586,15.246,22.869,11.434,25.727,18.422,5.4,20.963,8.576,32.08,7.94,15.564,7.94,26.681-3.494,21.917,4.129,27,26.363,6.67,35.574,6.988,16.2,1.271,18.422-5.4-.317-14.293,1.271-28.268,2.223-25.093,4.129-33.668,2.223-13.976.317-18.423-10.164-16.834-7.305-25.093,18.1-30.174,22.869-35.892,14.293-18.422,14.293-18.422-12.388-13.023-16.834-16.834a85.492,85.492,0,0,0-7.305-5.718,106.434,106.434,0,0,1-7.941,13.658c-4.129,5.717-8.576,17.152-14.928,23.822s-9.846,10.482-11.752,13.658a67.361,67.361,0,0,1-4.447,6.352L894.266,584.8Z",
    transform: "translate(-773.585 -403.302)",
    fill: "#fe9535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M939.25,591.953s.635,18.1-.635,19.057-6.67-.317-6.67-.317a103.194,103.194,0,0,1,9.211,12.388c5.4,8.258,13.023,14.293,16.834,15.564S966.567,645,966.567,645s1.905-7.306,3.493-14.294,2.224-11.434,1.271-16.2a20.207,20.207,0,0,0-3.494-7.94s-5.717,2.223-6.988-.635-.635-10.482-.635-10.482Z",
    transform: "translate(-821.429 -432.692)",
    fill: "#a53d35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M933.094,501.953s14.293,4.447,20.328,8.258,5.082,7.623,6.035,12.388,2.223,4.765,3.177,14.293-1.271,18.1-6.67,22.234-8.893,2.859-16.2-.635-8.576-1.906-13.976-11.752-9.211-12.7-5.717-21.916S933.094,508.623,933.094,501.953Z",
    transform: "translate(-815.908 -395.1)",
    fill: "#b24639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M910.881,563.026a7.1,7.1,0,0,0-.126,3.773,10.687,10.687,0,0,0,2.4,4.771,10.8,10.8,0,0,0,5.242,3.36,5.3,5.3,0,0,0,4.837-.657c4.006-3.438.816-9.22-1.979-12.3C918.508,558.947,912.46,558.493,910.881,563.026Z",
    transform: "translate(-812.498 -419.204)",
    fill: "#b24639"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(102.16 144.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M921.869,574.373a3.79,3.79,0,0,1-1.257-.211,4.8,4.8,0,0,1-3.016-4.612,3.472,3.472,0,0,1,.988-2.484,2.379,2.379,0,0,1,3.121-.165,1,1,0,0,1-1.318,1.511.443.443,0,0,0-.427.113,1.546,1.546,0,0,0-.359,1.073,2.791,2.791,0,0,0,1.675,2.673,2.036,2.036,0,0,0,1.582-.151,1.6,1.6,0,0,0,.84-.962,1,1,0,1,1,1.933.531,3.575,3.575,0,0,1-1.842,2.206A4.148,4.148,0,0,1,921.869,574.373Z",
    transform: "translate(-917.595 -566.394)",
    fill: "#8e342c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(130.115 131.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M967.285,559.827a1,1,0,0,1-.332-1.948,15.665,15.665,0,0,0,4.609-2.556c.592-.474.923-.94.862-1.215-.068-.309-.611-.62-1.092-.9l-.128-.073a12.51,12.51,0,0,1-5.551-6.8,1,1,0,0,1,1.9-.634,10.475,10.475,0,0,0,4.65,5.693l.122.07a3.627,3.627,0,0,1,2.054,2.2c.167.759.03,1.933-1.568,3.211a17.672,17.672,0,0,1-5.2,2.882A1.008,1.008,0,0,1,967.285,559.827Z",
    transform: "translate(-965.602 -545.023)",
    fill: "#8e342c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M972.94,542.877a5.694,5.694,0,0,1,1.3-1.876l.443-.39.478-.358.517-.306.543-.268c.186-.08.375-.161.563-.254s.387-.162.586-.238a3.127,3.127,0,0,1,.618-.125,3.043,3.043,0,0,1,.629.047,5.217,5.217,0,0,1,.612.194,4.158,4.158,0,0,1,.571.321,3.6,3.6,0,0,1,.5.456,2.745,2.745,0,0,1,.385.623.2.2,0,0,1-.081.245l-.011.006a5.883,5.883,0,0,1-.614.3,5.406,5.406,0,0,1-.523.223,3.9,3.9,0,0,1-.469.172,3.22,3.22,0,0,1-.436.128,1.429,1.429,0,0,1-.42.062,1.534,1.534,0,0,1-.427-.031l-.45-.067c-.151-.011-.3-.01-.457-.007l-.456.051-.457.087-.464.106-.461.144a7.263,7.263,0,0,0-1.812.918h0a.139.139,0,0,1-.194-.037A.142.142,0,0,1,972.94,542.877Z",
    transform: "translate(-838.548 -410.599)",
    fill: "#1c2941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M947.212,550.588a8.752,8.752,0,0,0-2.763.182l-.646.169-.623.219-.6.246L942,551.7c-.182.115-.362.23-.533.354l-.483.412a3.06,3.06,0,0,1-.477.384,2.913,2.913,0,0,1-.518.32,5.679,5.679,0,0,1-.56.291,6.017,6.017,0,0,1-.6.293,7.208,7.208,0,0,1-.663.3,6.7,6.7,0,0,1-.772.314l-.012,0a.169.169,0,0,1-.213-.111.24.24,0,0,1-.006-.029,3.818,3.818,0,0,1,.01-.89,5.7,5.7,0,0,1,.225-.826,6.876,6.876,0,0,1,.385-.751c.157-.229.33-.45.511-.665a5.286,5.286,0,0,1,.63-.544,5.4,5.4,0,0,1,.735-.383c.264-.091.528-.175.788-.258.268-.065.528-.139.786-.213l.784-.172.789-.108.792-.025.784.041a7.463,7.463,0,0,1,2.908.9.137.137,0,0,1-.081.254Z",
    transform: "translate(-823.6 -414.916)",
    fill: "#1c2941"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(130.131 119.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M966.631,530.213a1,1,0,0,1-.812-1.589,10.32,10.32,0,0,1,11.012-3.752,1,1,0,1,1-.572,1.922,8.261,8.261,0,0,0-8.815,3A1,1,0,0,1,966.631,530.213Z",
    transform: "translate(-965.629 -524.483)",
    fill: "#1c2941"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(108.786 125.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M929.977,543a1,1,0,0,1-.945-1.337,11.061,11.061,0,0,1,12.561-7.162,1,1,0,1,1-.387,1.967,9.058,9.058,0,0,0-10.285,5.864A1,1,0,0,1,929.977,543Z",
    transform: "translate(-928.974 -534.302)",
    fill: "#1c2941"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M964.389,581.673c6.611.945,7.306-4.447,7.306-4.447a28.054,28.054,0,0,1-13.023.317A7.069,7.069,0,0,0,964.389,581.673Z",
    transform: "translate(-832.593 -426.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(96.491 183.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M908.862,656.518a1,1,0,0,1-.778-1.633c5.2-6.419,8.665-20.121,8.7-20.258a1,1,0,0,1,1.945.486c-.145.579-3.611,14.268-9.087,21.033A1,1,0,0,1,908.862,656.518Z",
    transform: "translate(-907.86 -633.868)",
    fill: "#e5a652"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(155.252 179.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M1022.794,640.852a1,1,0,0,1-.4-.084c-5.246-2.3-13.071-11.949-13.4-12.359a1,1,0,0,1,1.56-1.258c.078.1,7.846,9.682,12.644,11.781a1,1,0,0,1-.4,1.92Z",
    transform: "translate(-1008.769 -626.778)",
    fill: "#e5a652"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(13.35 86.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M768.215,482.523a2.777,2.777,0,0,1-.961-.167,3.072,3.072,0,0,1-2.033-2.028c-.7-2.331,1.48-5.346,1.731-5.682a1,1,0,0,1,1.608,1.2h0c-.6.812-1.741,2.836-1.418,3.911.062.206.212.5.8.717.482.175,1.362-.187,2.351-.971,3.388-2.682,7.012-9.14,6.685-11.914a1,1,0,1,1,1.991-.235c.447,3.794-3.784,10.833-7.432,13.721A5.6,5.6,0,0,1,768.215,482.523Z",
    transform: "translate(-765.084 -466.467)",
    fill: "#74a6b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(8.921 30.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M762.2,389.984a1,1,0,0,1-.922-.608c-1.936-4.518-3.713-17.06-3.787-17.591a1,1,0,0,1,1.985-.28c.018.128,1.814,12.808,3.645,17.081a1,1,0,0,1-.921,1.4Z",
    transform: "translate(-757.478 -370.643)",
    fill: "#8e342c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    transform: "translate(5.014 34.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M755.583,394.527a1,1,0,0,1-.9-.554c-1.952-3.9-3.826-15.366-3.905-15.852a1,1,0,1,1,1.979-.321c.019.116,1.9,11.645,3.719,15.276a1,1,0,0,1-.9,1.451Z",
    transform: "translate(-750.769 -376.959)",
    fill: "#8e342c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(2.156 40.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M750.357,401.715a1,1,0,0,1-.883-.527c-2.279-4.233-3.549-12.366-3.6-12.71a1,1,0,0,1,1.981-.305c.013.081,1.271,8.137,3.386,12.065a1,1,0,0,1-.882,1.477Z",
    transform: "translate(-745.86 -387.322)",
    fill: "#8e342c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(112.689 96.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M939.857,493.268a1,1,0,0,1-.931-.63L935.75,484.7a1,1,0,0,1,1.862-.744l3.176,7.94a1,1,0,0,1-.93,1.375Z",
    transform: "translate(-935.678 -483.323)",
    fill: "#111b2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(116.819 309.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M982.58,858.276c-3.631,0-7.725-.036-11.836-.141-12.411-.318-26.717-5.556-27.32-5.778a1,1,0,0,1,.695-1.881c.144.054,14.6,5.346,26.677,5.655,12.218.314,24.285,0,24.405,0a1,1,0,1,1,.052,2C995.173,858.137,989.787,858.276,982.58,858.276Z",
    transform: "translate(-942.769 -850.414)",
    fill: "#468393"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(147.311 318.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M996.135,902.4a1,1,0,0,1-.729-1.69l5.014-5.308c-2.922-11.27,1.23-28.745,1.412-29.5a1,1,0,0,1,1.948.47c-.044.182-4.348,18.3-1.281,29.029a1,1,0,0,1-.235.963l-5.4,5.717A1,1,0,0,1,996.135,902.4Z",
    transform: "translate(-995.133 -865.14)",
    fill: "#468393"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M1003.056,851.7c.592-3.545-4.865-4.361-5.424-1.015C997.127,853.708,1002.488,855.095,1003.056,851.7Z",
    transform: "translate(-848.851 -539.874)",
    fill: "#964c3d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    transform: "translate(155.985 306.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M1011.031,854.733c-.032,0-.065,0-.1,0a1,1,0,0,1-.9-1.094l.728-7.543a1,1,0,0,1,2,.192l-.729,7.543A1,1,0,0,1,1011.031,854.733Z",
    transform: "translate(-1010.028 -845.186)",
    fill: "#468393"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(146.041 471.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M1002.212,1135.364a1,1,0,0,1-.283-.041,19.907,19.907,0,0,1-8.721-5.055,1,1,0,0,1,1.488-1.343,18.266,18.266,0,0,0,7.8,4.475,1,1,0,0,1-.282,1.964Z",
    transform: "translate(-992.951 -1128.595)",
    fill: "#8e342c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(83.82 220.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M891.753,779.689a1,1,0,0,1-.806-1.6c2.308-3.129,5.735-8.9,2.747-12.4a10.4,10.4,0,0,0-2.641-1.978,13.359,13.359,0,0,1-2.873-2.1c-3.809-3.963-1.9-10.585,1.828-14.8,1.073-1.215,2.269-2.348,3.426-3.444,2.491-2.361,4.844-4.591,6.049-7.544,2.252-5.519-.165-11.7-2.5-17.67l-.375-.961c-3.488-8.97-3.327-15.735.48-20.107a1,1,0,1,1,1.512,1.316c-3.278,3.766-3.32,9.843-.123,18.064l.374.957c2.364,6.045,5.045,12.9,2.49,19.157-1.368,3.354-3.99,5.839-6.526,8.243-1.125,1.066-2.288,2.169-3.3,3.316-3.179,3.6-4.753,9.1-1.884,12.087a11.7,11.7,0,0,0,2.461,1.774,12.07,12.07,0,0,1,3.133,2.4c2.922,3.426,2,8.577-2.659,14.9A1,1,0,0,1,891.753,779.689Z",
    transform: "translate(-886.101 -696.733)",
    fill: "#111b2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424",
    transform: "translate(96.4 275.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M911.553,828.587a1.013,1.013,0,0,1-.137-.009,4.035,4.035,0,0,1-2.917-2.02,5.91,5.91,0,0,1-.459-4.911c.906-2.443,3.044-4.081,4.931-5.526l.09-.069c1.763-1.35,3.527-2.834,4.034-4.808.7-2.737-1.215-5.641-2.906-8.2l-.083-.125c-2.764-4.189-3.394-7.658-1.87-10.309a1,1,0,0,1,1.738,1c-1.115,1.94-.507,4.7,1.806,8.206l.082.125c1.921,2.91,4.1,6.209,3.175,9.807-.666,2.593-2.8,4.405-4.756,5.9l-.09.069c-1.753,1.343-3.566,2.73-4.27,4.632a3.886,3.886,0,0,0,.3,3.184,2.074,2.074,0,0,0,1.47,1.063,1,1,0,0,1-.135,2Z",
    transform: "translate(-907.705 -792.103)",
    fill: "#111b2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425",
    transform: "translate(146.206 123.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M1003.19,560.46a1,1,0,0,1-.334-.058c-3.115-1.1-4.265-4.728-4.023-7.84a27.789,27.789,0,0,1,.62-3.687,20,20,0,0,0,.613-4.3c-.028-4.511-3.129-8.4-6.581-12.319a1,1,0,0,1,1.5-1.325c3.713,4.215,7.05,8.428,7.082,13.631a21.844,21.844,0,0,1-.657,4.737,25.832,25.832,0,0,0-.582,3.421c-.176,2.272.59,5.053,2.691,5.793a1,1,0,0,1-.333,1.948Z",
    transform: "translate(-993.235 -530.59)",
    fill: "#111b2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(99.448 155.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M916.456,598.517a1,1,0,0,1-.756-.344,11.514,11.514,0,0,1-1.791-12.1,1,1,0,0,1,1.828.823,9.6,9.6,0,0,0,1.474,9.958,1,1,0,0,1-.755,1.661Z",
    transform: "translate(-912.938 -585.484)",
    fill: "#111b2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    transform: "translate(132.576 237.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M970.83,737.576a1,1,0,0,1,0-2c3.358-.013,6.5-1.736,9.4-3.6.415-.266.829-.537,1.243-.808a29.53,29.53,0,0,1,8.521-4.332c3.6-.94,8.349-.355,10.834,3.069a1,1,0,0,1-1.622,1.177c-1.93-2.659-5.764-3.075-8.706-2.307-2.836.74-5.425,2.433-7.93,4.07-.419.274-.837.548-1.257.817-3.151,2.024-6.6,3.9-10.472,3.915Z",
    transform: "translate(-969.828 -726.432)",
    fill: "#e5a652"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(128.609 274.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M975.7,812.67a1,1,0,0,1-.4-.083A20.913,20.913,0,0,1,963.3,790.333a1,1,0,1,1,1.975.343A19.113,19.113,0,0,0,976.1,810.748a1,1,0,0,1-.4,1.922Z",
    transform: "translate(-963.016 -789.502)",
    fill: "#e5a652"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(146.828 380.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M1012.229,1011.958a1,1,0,0,1-.882-.526,251.027,251.027,0,0,1-16.991-39.076,1,1,0,0,1,1.9-.641,249.032,249.032,0,0,0,16.854,38.764,1,1,0,0,1-.881,1.479Z",
    transform: "translate(-994.303 -971.033)",
    fill: "#468393"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(101.804 393.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M944.977,1020.32a1,1,0,0,1-.756-.344,136.157,136.157,0,0,0-26.793-23.609,1,1,0,0,1,1.117-1.664,138.127,138.127,0,0,1,27.188,23.957,1,1,0,0,1-.755,1.661Z",
    transform: "translate(-916.984 -994.532)",
    fill: "#468393"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(739.692 432.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M739.71,539.677a82.956,82.956,0,0,0,9.19,27.631,85.683,85.683,0,0,0,8,12.032,72.565,72.565,0,0,0,4.818,5.449,18.077,18.077,0,0,0,5.6,4.245c.856.357,1.505-.778,1.128-1.467a27.736,27.736,0,0,0-4.3-5.2c-1.6-1.7-3.117-3.482-4.585-5.3a82.04,82.04,0,0,1-7.865-11.7,83.306,83.306,0,0,1-9.375-26.406c-.295-1.724-2.856-.973-2.605.718Z",
    transform: "translate(-739.692 -537.979)",
    fill: "#f2eadf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(917.856 284.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M1046.589,287.3c8.4-.835,13.867,9.364,17.11,15.636a63.541,63.541,0,0,1,4.659,11.794c1.143,4.018,1.615,8.2,2.888,12.175a1.145,1.145,0,0,0,2.238-.3c.571-4.618-.747-9.5-2.123-13.885a67.789,67.789,0,0,0-5.608-12.964c-3.65-6.473-10.525-17.079-19.423-14.367-1,.306-.879,2.028.259,1.915Z",
    transform: "translate(-1045.65 -284.952)",
    fill: "#f2eadf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    transform: "translate(867.664 821.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M960.084,1217.193a65.02,65.02,0,0,0,32.465,3.914c10.8-1.482,21.816-5.379,29.762-13.067a.908.908,0,0,0-1.1-1.421c-9.209,5.195-18.741,9.639-29.271,11.315a64.916,64.916,0,0,1-31.367-2.531c-1.142-.4-1.587,1.364-.493,1.789Z",
    transform: "translate(-959.456 -1206.5)",
    fill: "#f2eadf"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionimage);
export default __webpack_public_path__ + "static/media/visionimage.50c0bcc4dab63a78966cb6ba96dca54f.svg";
export { ForwardRef as ReactComponent };